<ng-template #getTiktokCatIdModal let-modal>
  <div class="getTiktokCatIdModal-modal actions-modal">
    <div class="modal-header">
      Tìm Category cho Tiktok
    </div>

    <div class="modal-body">
      <form>

        <div class="form-group">
          <label>Market</label>
          <ng-select [items]="markets"
                     placeholder="Market"
                     [(ngModel)]="searchModel.market"
                     (change)="searchTiktokCat()"
                     name="market">
          </ng-select>
        </div>

        <div class="form-group">
          <label>Keyword</label>
          <input class="form-control" name="keyword" [(ngModel)]="searchModel.keyword" (change)="searchTiktokCat()"/>
        </div>

        <div class="form-group">
          <ul>
            <li *ngFor="let r of result">{{r}}</li>
          </ul>
        </div>

      </form>
    </div>
  </div>
</ng-template>

<button class="btn btn-primary" (click)="openModal()" style="margin-right: 10px">Tìm tiktok Category</button>
